const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

export const BRAND_MODAL_PAPER_PROPS = {
  sx: {
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "#00336C",
    backgroundImage: "none",
    boxShadow: "0 8px 32px rgba(0,51,108,0.18)",
  },
};

export const BRAND_MODAL_TITLE_SX = {
  fontWeight: 800,
  color: "white",
  background: `linear-gradient(135deg, ${BRAND_BLUE} 0%, #1d4f91 100%)`,
  borderBottom: `3px solid ${BRAND_GREEN}`,
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
};
